import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../../../lib/apiClient';
import type { DivisionSearchResult } from './useAddDivisionSearch';

interface DivisionUserPayload {
  divisionUuid: string;
  user: {
    authServiceUuid: string;
  };
  sendInvite: boolean;
}

export const useAddDivisionMutation = (userId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (divisions: DivisionSearchResult[]) => {
      const divisionsUsers: DivisionUserPayload[] = divisions.map((division) => ({
        divisionUuid: division.uuid,
        user: {
          authServiceUuid: userId,
        },
        sendInvite: false,
      }));

      await apiClient()
        .post(`broadcast/api/admin/user/${userId}/add_divisions`, {
          json: divisionsUsers,
        })
        .json();
    },
    onSuccess: () => {
      // Invalidate the user divisions query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: ['userDivisions', userId] });
    },
  });
};
